import styles from './styles.module.less';

export { NoPendingApprovalReturnsPlaceholder } from './no-pending-approval-returns';
export { NoPendingPaymentReturnsPlaceholder } from './no-pending-payment-returns';
export { NoCompletedReturnsPlaceholder } from './no-completed-returns';
export { NoNeedsAttentionReturnsPlaceholder } from './no-needs-attention-returns-placeholder';
export { NoSearchResultsGridPlaceholder } from './no-search-results';
export { NoFilterResultsGridPlaceholder } from './no-filter-results';
export { ActivateReturnsGridPlaceholder } from './activate-enhanced-returns';

export const PlaceholderWrapper = ({ children }) => <div className={styles.placeholder}>{children}</div>;

export const PlaceholderBody = ({ children }) => <div className={styles.header}>{children}</div>;

export const PlaceholderFooter = ({ children }) => <div className={styles.buttons}>{children}</div>;
